<template>
  <div>
    <Head title="Pagamentos" />
    <div class="shadow_box rounded-lg p-6">
      <div class="mb-6 flex justify-between">
        <h1 class="text-2xl text-gray-777 font-roboto uppercase">Pagamentos</h1>
      </div>

      <div class="flex flex-wrap mb-6 lg:flex-nowrap">
        <div class="w-full lg:w-[310px] flex-shrink-0">
          <div class="mb-6">
            <template v-if="this.specialties.length">
              <div class="mt-6 min-w-[300px] max-w-full" v-for="(specialty, specialty_index) in this.specialties">
                <div class="bg-primary text-white rounded-lg p-5 mt-5 lg:mt-0">
                  <div class="font-bold text-xl">{{ specialty.price_mask }}</div>
                  <div class="font-light text-sm">Valor do atendimento {{ specialty.name }}</div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="mt-2 ml-0 mb-8 lg:rounded-lg lg:p-4 lg:border lg:mb-0 lg:ml-4 lg:mt-0 flex-initial lg:flex-1 w-full lg:w-auto h-[430px] lg:h-auto">
          <span class="">Rentabilidade Mensal</span>
          <div class="w-full flex flex-wrap mt-3">
            <div class="w-full lg:w-1/3">
              <DateMonthInput class="w-full lg:w-[150px]" :clearable="false" placeholder="Mês" v-model="selectedDate" />
            </div>
            <div class="w-1/2 mt-4 lg:mt-0 lg:w-1/3">
              <div class="text-xs text-gray-500">{{ selectedMonthFormatted }}</div>
              <div class="text-blue-500 font-semibold">{{ total_month }}</div>
              <div class="text-xs text-gray-500">Lucro do mês</div>
            </div>
            <div class="w-1/2 mt-4 lg:mt-0 lg:w-1/3">
              <div class="text-xs text-gray-500">{{ selectedYearFormatted }}</div>
              <div class="text-gray-500 font-semibold">{{ total_year }}</div>
              <div class="text-xs text-gray-500">Lucro do ano</div>
            </div>
          </div>
          <bar-chart class="my-4" :height="300" :chartData="this.chartLineData()" />
        </div>
      </div>

      <data-table
        v-if="loadTable"
        v-model:columns="columns"
        route="payments/list"
        no-data-label="Nenhum agendamento cadastrado"
        no-result-label="Nenhum agendamento encontrado"
      >
        <template #table.cell.content.date_end="{ value, row }">
          <template v-if="row.type_service != 'telemedicine'">{{ value }}</template>
          <template v-else>
            <popover class="mr-8 md:mr-0" placement="bottom-end">
              <template #default>
                <span class="text-primary font-semibold cursor-pointer">
                  {{ value }}
                </span>
              </template>
              <template #dropdown>
                <div class="p-4 bg-white shadow_box rounded-lg text-xs">
                  <div class="grid gap-4 grid-cols-3">
                    <div></div>
                    <div>Entrada</div>
                    <div>Saída</div>
                    <div>Profissional</div>
                    <div>
                      {{ row.professional_date_join ? row.professional_date_join.substr(10, 6) : '-' }}
                    </div>
                    <div>
                      {{ row.professional_date_out ? row.professional_date_out.substr(10, 6) : '-' }}
                    </div>
                    <div>Paciente</div>
                    <div>
                      {{ row.patient_date_join ? row.patient_date_join.substr(10, 6) : '-' }}
                    </div>
                    <div>
                      {{ row.patient_date_out ? row.patient_date_out.substr(10, 6) : '-' }}
                    </div>
                  </div>
                </div>
              </template>
            </popover>
          </template>
        </template>

        <template #table.content.body.date_end="{ value, row }">
          <template v-if="row.type_service != 'telemedicine'">{{ value }}</template>
          <template v-else>
            <popover class="mr-8 md:mr-0" placement="bottom-end">
              <template #default>
                <span class="text-primary font-semibold cursor-pointer">
                  {{ value }}
                </span>
              </template>
              <template #dropdown>
                <div class="p-4 bg-white shadow_box rounded-lg text-xs">
                  <div class="grid gap-4 grid-cols-3">
                    <div></div>
                    <div>Entrada</div>
                    <div>Saída</div>
                    <div>Profissional</div>
                    <div>
                      {{ row.professional_date_join ? row.professional_date_join.substr(10, 6) : '-' }}
                    </div>
                    <div>
                      {{ row.professional_date_out ? row.professional_date_out.substr(10, 6) : '-' }}
                    </div>
                    <div>Paciente</div>
                    <div>
                      {{ row.patient_date_join ? row.patient_date_join.substr(10, 6) : '-' }}
                    </div>
                    <div>
                      {{ row.patient_date_out ? row.patient_date_out.substr(10, 6) : '-' }}
                    </div>
                  </div>
                </div>
              </template>
            </popover>
          </template>
        </template>
      </data-table>
    </div>
  </div>
<modal-update-photo-profile ref="modalUpdatePhotoProfile" />

</template>

<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout/Layout'
import DataTable from '@/Shared/Components/DataTable'
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import format from 'date-fns/format';
import TextareaInput from '@/Shared/Fields/TextareaInput'
import SelectInput from '@/Shared/Fields/SelectInput'
import MoneyInput from '@/Shared/Fields/MoneyInput'
import TextInput from '@/Shared/Fields/TextInput'
import MaskInput from '@/Shared/Fields/MaskInput'
import EmailInput from '@/Shared/Fields/EmailInput'
import BarChart from '@/Shared/Components/BarChart'
import DateMonthInput from '@/Shared/Fields/DateMonthInput'
import Popover from '@/Shared/Components/Popover'
import ModalUpdatePhotoProfile from '@/Shared/Modal/ModalUpdatePhotoProfile'

export default {
  props: {
    specialties: [],
    total_month: '',
    total_year: '',
    earnedLastYear: Object,
  },
  components: {
    Head,
    Link,
    DataTable,
    format,
    TextareaInput,
    SelectInput,
    MoneyInput,
    TextInput,
    MaskInput,
    EmailInput,
    BarChart,
    DateMonthInput,
    Popover,
    ModalUpdatePhotoProfile,
  },
  layout: Layout,
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  watch: {
    selectedDate(selectedDateNew, selectedDateOld) {
      this.updateTotals();
    },
  },
  computed: {
    selectedMonthFormatted: function() {
      return this.selectedDate ? this.$filters.capitalize(this.$filters.formatDate(this.selectedDate + '-01 00:00:00', 'LLLL/yyyy')) : '';
    },
    selectedYearFormatted: function() {
      return this.selectedDate ? this.$filters.formatDate(this.selectedDate + '-01 00:00:00', 'yyyy') : '';
    },
  },
  mounted() {
    let now = new Date();
    this.selectedDate = now.getFullYear() + '-' + (now.getMonth() + 1).toString().padStart(2, '0');

    if(this.user.professional){
      if(!this.user.photo) {
        this.$refs.modalUpdatePhotoProfile.openModalUpdatePhotoProfile();
      }
    }
  },
  data() {
    return {
      selectedDate: (new Date()).getFullYear() + '-' + ((new Date()).getMonth() + 1).toString().padStart(2, '0'),
      loadTable: true,
      columns: [
        {
          uniqid: 'patient_name',
          label: 'Paciente',
          field: 'patient_user.name',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.patient?.user?.name || row.patient_name || 'Nome não disponível',
        },
        {
          uniqid: 'date_start',
          label: 'Data da Consulta',
          field: 'date_start',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => this.$filters.formatDate(row.date_start) || '',
        },
        {
          uniqid: 'date_end',
          label: 'Horário',
          field: 'date_end',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => {
            const startTime = row.date_start ? row.date_start.substr(11, 5) : '';
            const endTime = row.date_end ? row.date_end.substr(11, 5) : '';
            return `${startTime} - ${endTime}`;
          },
        },
        {
          uniqid: 'consultation_price',
          label: 'Valor',
          field: 'payments.consultation_price',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => {
            const price = row.payment?.consultation_price || 0;
            return price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
          },
        },
      ],
    }
  },
  methods: {
    submitForm() {
      this.reloadTable();
      this.updateTotals();
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
    updateTotals() {
      this.$inertia.reload({
        method: 'put',
        only: [
          'flash',
          'specialties',
          'total_month',
          'total_year',
        ],
        data: {
          selectedDate: this.selectedDate,
        }
      });
    },
    chartLineData() {
      return {
        labels: this.earnedLastYear.categories,
        datasets: this.earnedLastYear.series
      }
    },
    openModalUpdatePhotoProfile() {
      this.$refs.modalUpdatePhotoProfile.openModalUpdatePhotoProfile();
    },
  },
}
</script>
